import { Component, OnInit, Input } from '@angular/core';
import { EditFacModalService } from '../service/edit-fac-modal.service';
import { FullFacModel } from 'src/app/core/models/edit-fac-modal.model';

@Component({
  selector: 'app-modal-log',
  templateUrl: './modal-log.component.html',
  styleUrls: ['./modal-log.component.scss']
})
export class ModalLogComponent implements OnInit {
  @Input() facItem: FullFacModel;
  public facHistory = [];
  public historyListFilter = [];
  public loading = true;
  public historyFilterOpen = false;
  public historyFilter = {value: 'Filtros', type: 'all'};
  public combosList = [
    {
      value: 'Tudo',
      type: 'all'
    },
    {
      value: 'Contatos',
      type: 'contacts'
    },
    {
      value: 'Dados cadastrais',
      type: 'registration_data'
    },
    {
      value: 'Outros',
      type: 'others'
    }
  ];

  constructor(
    private facModalService: EditFacModalService
  ) { }

  ngOnInit(): void {
    this.getFacHistory();
  }

  getFacHistory() {
    this.facModalService.getFacHistory(this.facItem.id).subscribe(resp => {
      this.facHistory = resp;
      this.setFilter(this.historyFilter);
      this.loading = false;
     },
      err => {
      this.historyListFilter = err.error;
      this.loading = false;
    });
  }

  setFilter(item) {
    this.historyFilter = item;
    this.historyFilterOpen = false;
    this.historyFilterMatch();
  }

  historyFilterMatch() {
    this.historyListFilter = [];
    if (this.facHistory && this.facHistory.length > 0) {
      this.historyListFilter = this.facHistory.filter(history => {
        if (history.type === 'activities') {
          return false;
        }
        if (history.type === this.historyFilter.type || this.historyFilter.type === 'all') {
          return true;
        }
        return false;
      });
    }
  }
}
